import { useContext } from "react"
import { UserStateContext } from "../../contexts/UserStateProvider"
import { useTheme } from "../theme-provider";

export const MergoioLogo = ({ width }: { width?: number }) => {
    const {theme} = useTheme();
    return (
        <img src={theme === "dark" ? "/mergoiologo.png" : "/mergoiologo_black.png"} width={width ? width : 100} alt="Mergoio Logo" />
    )
}